<template>

  <section class="bulk-issue-overview">

    <div class="bulk-issue-overview__amount">
       <span class="bulk-issue-overview__label">Tổng tiền phát hành</span> <strong
        class="bulk-issue-overview__value"
        >{{ totalAmountText }}</strong
      >
    </div>

    <div class="bulk-issue-overview__indicators">

      <div
        v-for="stat in stats"
        :key="stat.key"
        class="bulk-issue-overview__indicator"
        :class="`bulk-issue-overview__indicator--${stat.tone}`"
      >
         <span class="bulk-issue-overview__indicator-label">{{ stat.label }}</span
        > <strong class="bulk-issue-overview__indicator-value">{{ stat.value }}</strong
        >
      </div>

    </div>

  </section>

</template>

<script>
  export default {
    name: 'BulkIssueOverview',
    props: {
      totalAmountText: {
        type: String,
        default: '0 ₫',
      },
      stats: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-overview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.9rem 1rem;
    border: 1px solid #dde5f1;
    border-radius: 12px;
    background: #f8fafc;
  }

  .bulk-issue-overview__amount {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .bulk-issue-overview__label {
    color: #748093;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .bulk-issue-overview__value {
    color: #1f2a3d;
    font-size: 1.45rem;
    font-weight: 700;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
  }

  .bulk-issue-overview__indicators {
    display: grid;
    grid-template-columns: repeat(3, minmax(88px, 1fr));
    gap: 0.65rem;
    min-width: 0;
  }

  .bulk-issue-overview__indicator {
    padding: 0.65rem 0.8rem;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
  }

  .bulk-issue-overview__indicator--success {
    background: #f3fbf7;
    border-color: #cfe9db;
  }

  .bulk-issue-overview__indicator--danger {
    background: #fff4f4;
    border-color: #f0d0d0;
  }

  .bulk-issue-overview__indicator--muted {
    background: #f3f5f8;
    border-color: #e1e7ef;
  }

  .bulk-issue-overview__indicator-label {
    display: block;
    color: #748093;
    font-size: 0.73rem;
    font-weight: 600;
    line-height: 1.35;
  }

  .bulk-issue-overview__indicator-value {
    display: block;
    margin-top: 0.22rem;
    color: #1f2a3d;
    font-size: 1rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 991.98px) {
    .bulk-issue-overview {
      flex-direction: column;
      align-items: stretch;
    }

    .bulk-issue-overview__indicators {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (max-width: 575.98px) {
    .bulk-issue-overview__indicators {
      grid-template-columns: 1fr;
    }
  }
</style>

